<template>
	<div class="full-layer-mid-header">
		<div class="container">
			<div class="row clearfix align-items-center">
				<div class="col-lg-3 col-md-9 col-sm-6">
					<div class="brand-logo text-lg-center">
						<router-link :to="{name: 'Home'}">
							<b><h1 class="text-lg-center">{{ shopName }}</h1></b>
						</router-link>
					</div>
				</div>
				<div class="col-lg-6 u-d-none-lg">
					<!-- {{ searchFocus ? "in box" : "outside" }} -->
					<form
						class="form-searchbox"
						:style="searchFocus && {position: 'relative', 'z-index': 999998}"
					>
						<div class="search-input">
							<!-- <i class="fa fa-microphone" @click="handleVoiceSearch"></i> -->
							<label class="sr-only" for="search-landscape">Search</label>
							<input
								id="search-landscape"
								type="text"
								class="text-field"
								v-model="searchString"
								placeholder="Search everything"
								@focus="handleSearchFocus"
								@blur="handleBlurSearch"
								autocomplete="off"
								@input="handleSearchInput"
								ref="searchInput"
							/>
						</div>
						<div class="select-box-position">
							<div class="select-box-wrapper select-hide">
								<label class="sr-only" for="select-category">Choose category for search</label>
								<select class="select-box" id="select-category" v-model="categoryId">
									<option selected="selected" value="">All</option>
									<option
										:value="category.id"
										v-for="category in getCategories"
										:key="category.id"
									>
										{{ category.name }}
									</option>
								</select>
							</div>
						</div>
						<button
							id="btn-search"
							type="submit"
							class="button button-primary fas fa-search"
							@click.prevent="handleSearch"
						></button>
					</form>
					<div
						class="dropdown-menu autosuggest_result shadow"
						:style="searchFocus && {'z-index': 999998}"
						v-if="showSearchResult"
					>
						<a v-if="autoSuggest.length == 0" class="dropdown-item result_item"
							>No Result Found</a
						>
						<a
							class="dropdown-item result_item"
							v-for="(result, index) in autoSuggest"
							:key="index"
							@click="handleSearchResultClick(result)"
							>{{ result.product_name }}</a
						>
					</div>
				</div>
				<div class="col-lg-3 col-md-3 col-sm-6">
					<nav>
						<ul class="mid-nav g-nav">
							<li class="u-d-none-lg">
								<a href="/">
									<i class="ion ion-md-home u-c-brand"></i>
								</a>
							</li>
							<li class="u-d-none-lg">
								<router-link :to="{name: 'Wishlist'}">
									<i class="far fa-heart"></i>
								</router-link>
							</li>
							<li>
								<a id="mini-cart-trigger">
									<i class="ion ion-md-basket"></i>
									<span class="item-counter"> {{ getCarts.length }}</span>
									<span class="item-price">{{ formatCurrency(getTotal) }}</span>
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>

	<div class="fixed-responsive-container">
		<div class="fixed-responsive-wrapper">
			<button
				type="button"
				class="button fas fa-search"
				id="responsive-search"
				@click="handleResponsiveSearchButton"
			></button>
		</div>
		<div class="fixed-responsive-wrapper">
			<router-link :to="{name: 'Wishlist'}" id="wishlist_icon">
				<i class="far fa-heart"></i>
				<!-- <span class="fixed-item-counter">4</span> -->
			</router-link>
		</div>
	</div>
	<div class="responsive-search-wrapper">
		<button
			type="button"
			class="button ion ion-md-close"
			id="responsive-search-close-button"
			@click="handleResponsiveSearchCloseButton"
		></button>
		<div class="responsive-search-container">
			<div class="container">
				<p>Start typing and press Enter to search</p>
				<p @click="handleVoiceSearch">
					or try voice search <i class="fa fa-microphone"></i>
				</p>
				<form class="responsive-search-form" @submit.prevent="handleSearch">
					<label class="sr-only" for="search-text">Search</label>
					<input
						id="search-text"
						type="text"
						class="responsive-search-field"
						placeholder="PLEASE SEARCH"
						v-model="searchString"
						autocomplete="off"
						@input="handleSearchInput"
					/>
					<i @click.prevent="handleSearch" class="fas fa-search"></i>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
	import {publicPath} from "../../../vue.config";
	import {mapActions, mapGetters} from "vuex";
	import {formatCurrency} from "../../utils/common_functions";
	import axios from "axios";
	export default {
		computed: {
			...mapGetters("cart", ["getCarts", "getTotal"]),
			...mapGetters("cat", ["getCategories"]),
		},
		data() {
			return {
				searchFocus: false,
				publicPath: publicPath,
				searchString: "",
				categoryId: "",
				shopName: "",
				showSearchResult: false,
				autoSuggest: [],
				id: null,
			};
		},
		methods: {
			formatCurrency,
			...mapActions("cart", ["toggleCart"]),
			toggleMyCart() {
				this.toggleCart();
			},
			handleSearchFocus() {
				this.searchFocus = true;
			},
			handleResponsiveSearchButton() {
				$(".responsive-search-wrapper").stop(true, true).fadeIn(); //open responsive search
			},
			handleResponsiveSearchCloseButton() {
				$(".responsive-search-wrapper").stop(true, true).fadeOut();
			},
			handleSearch() {
				if (!this.searchString) {
					return;
				}
				$(".responsive-search-wrapper").stop(true, true).fadeOut(); //hide responsive search
				this.searchFocus = false;
				this.$router.push({
					name: "Search",
					query: {q: this.searchString, category_id: this.categoryId},
				});
				this.searchString = ""; //clear search string
				this.showSearchResult = false;
			},
			handleSearchInput() {
				if (this.searchString == "") return;
				this.debounce(this.fetchSearchResult, 500);
			},
			handleBlurSearch() {
				this.searchFocus = false;
				setTimeout(() => {
					this.showSearchResult = false;
				}, 300);
			},

			handleSearchResultClick(result) {
				this.$router.push({
					name: "ProductDetail",
					params: {id: result.id, slug: result.product_slug},
				});
				this.showSearchResult = false;
			},

			async fetchSearchResult() {
				let token = localStorage.getItem("token");
				let LocalLatLng = JSON.parse(localStorage.getItem("location"));
				let url =
					process.env.VUE_APP_API_URL +
					"/api/warehouses/get-range?searchBy=" +
					this.searchString;
				if (LocalLatLng) {
					url = url + `&latitude=${LocalLatLng.lat}&longitude=${LocalLatLng.lng}`;
				}
				try {
					let {data} = await axios.post(url, {
						headers: {
							Authorization: `Bearer ${token}`,
						},
					});
					console.log("Auto Suggest Result", data);
					this.showSearchResult = true;
					this.autoSuggest = data.payload.data;
				} catch (error) {
					console.log(error);
				}
			},

			debounce(fn, delay) {
				if (this.id) clearTimeout(this.id);
				this.id = setTimeout(() => {
					fn();
				}, delay);
			},
			handleVoiceSearch() {
				var recognition = new window.webkitSpeechRecognition();
				recognition.lang = "en-US";
				recognition.interimResults = false;
				recognition.maxAlternatives = 5;
				recognition.start();
				const changeSearchString = this.changeSearchString;
				recognition.onresult = function (event) {
					console.log("You said: ", event.results[0][0].transcript);
					changeSearchString(event.results[0][0].transcript);
				};
			},
			changeSearchString(value) {
				this.searchString = value;
			},
		},
		mounted() {
			this.shopName = process.env.VUE_APP_SHOP_NAME
				? process.env.VUE_APP_SHOP_NAME
				: "CalsoB";
			console.log("Search Bar Mounted");
			this.searchString = this.$route.query.q;
		},
		watch: {
			$route(to, from) {
				this.searchString = to.query.q; //watch for changes in query
			},
			searchFocus(val) {
				if (val) {
					$(".body-backdrop").css("display", "block");
				} else {
					$(".body-backdrop").css("display", "none");
				}
			},
		},
	};
</script>

<style scoped>
	.form-searchbox .select-hide {
		visibility: visible;
	}

	.autosuggest_result {
		display: block;
		width: 100%;
	}
	.result_item {
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		padding: 10px;
		width: 65%;
		margin: auto;
	}
	.result_item:last-child {
		border-bottom: 0px;
	}
	/* #responsive-search,
	#wishlist_icon {
		border: 2px solid #292929;
	} */
	.dropdown-item:active {
		background-color: white !important;
	}
	.search-input {
		position: relative;
	}
	.search-input .fa {
		position: absolute;
		padding: 15px;
		right: 170px;
		cursor: pointer;
	}
</style>
